import { orgAccessCompanyIds } from './orgAccess';

// Roles that act across tenants without a company (firestore.rules platformRoles()).
export const PLATFORM_ROLES = ['superadmin', 'admin', 'accounting', 'operations', 'dispatch', 'brokerage', 'warehouse'];

const listOf = (value) => (Array.isArray(value) ? value : []);

// The same "provisioned" test firestore.rules applies (isProvisioned()): a
// platform role, or at least one company (connectedCompanies in either stored
// shape, the legacy companies array) or hierarchy root. Earlier first-time
// Google/Microsoft sign-ins self-created role-'user' profiles with no company;
// those still exist and pass a bare exists() check, but the rules give them
// nothing (not even their lastLogin write), so they are refused like a missing
// profile instead of landing in an empty Company Admin shell.
export const isProvisionedProfile = (userData) => {
    if (!userData) return false;
    if (PLATFORM_ROLES.includes(userData.role)) return true;
    const cc = userData.connectedCompanies;
    const connected = Array.isArray(cc) ? cc : listOf(cc && cc.companies);
    const roots = listOf(userData.hierarchyAccess && userData.hierarchyAccess.rootCompanyIds);
    // An organization access grant (server-written orgAccess lists) also
    // provisions the profile, as the rules' isProvisioned() counts it.
    return connected.length > 0 || listOf(userData.companies).length > 0 || roots.length > 0
        || orgAccessCompanyIds(userData).all.length > 0;
};
